export default __webpack_public_path__ + "static/mitech-client-logo-01-9700d2fe455ad55978af9c68aee8d226.png";